import {
  BoltTaskStatuses,
  BoltTaskTypePriorities,
  IBoltTaskTemplate,
  INewBoltTaskTemplate,
  SLAUnits,
  TaskExecutionTypeFieldSchema,
} from "@bolt/core";
import {
  FieldFormV2,
  FieldFormV2Module,
  Footer,
  FieldV2,
  SwitchFieldProps,
  ActionButtons,
  fieldTypes,
} from "@ucl/library";
import { useRef, useState } from "react";
import { CreateBoltTaskTemplateFormContainer } from "./builders/CreateBoltTaskTemplateFormContainer";
import { RichTextEditorsOutputTextTypes } from "../../types/globalTypes";
import {
  useTaskTemplateSubmit,
  TaskTemplateSubmitMode,
} from "./useTaskTemplateSubmit";

export type BoltTaskTypes = (IBoltTaskTemplate | INewBoltTaskTemplate)[];
export type BoltTaskTemplates = (IBoltTaskTemplate | INewBoltTaskTemplate)[];

export interface CreateBoltTaskTemplateFormProps {
  // extends BoltInteraction<
  //   {
  //     onSubmitSuccessfully: (
  //       taskType: IBoltTaskTemplate | IBoltTaskTemplate[]
  //     ) => Promise<void>;
  //   },
  //   {}
  // > {
  apiBaseUrl: string;
  assigneeOdataUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  // currentUser: { id: string };
  richTextEditorsOutputTextType?: RichTextEditorsOutputTextTypes;
  workflowType?: "Single Step" | "Multi-Step";
  showWorkflowTypeSelector?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
  entityTypeOptions?: fieldTypes.Option<string>[] | [];
}

export const defaultTaskTemplate: INewBoltTaskTemplate = {
  hasMultiSteps: false,
  taskTemplateName: "",
  taskTemplateDescription: "",
  shortDescription: "",
  taskTemplateSOP: "",
  taskTemplateSOP_AsList: [],
  initialStatus: BoltTaskStatuses.New,
  taskPriority: BoltTaskTypePriorities.Normal,
  orderNumber: 0,
  sequenceNumber: 0,
  onHoldDays: 0,
  slaUnit: SLAUnits.Day,
  expectedSLAUnit: SLAUnits.Minute,
  isActive: true,
  timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const CreateBoltTaskTemplateForm: React.FC<
  CreateBoltTaskTemplateFormProps
> = ({
  apiBaseUrl,
  assigneeOdataUrl,
  getAuthRequestHeader,
  richTextEditorsOutputTextType,
  entityTypeOptions,
  // actions,
  workflowType,
  showWorkflowTypeSelector = true,
  onSave,
  onCancel,
}) => {
  const taskTypeFormRef = useRef<FieldFormV2Module<BoltTaskTemplates>>(null);
  const { submitTaskTemplates } = useTaskTemplateSubmit(
    TaskTemplateSubmitMode.CREATE
  );
  const [taskExecutionTypeData, setTaskExecutionTypeData] =
    useState<TaskExecutionTypeFieldSchema>({});
  const [localTaskTemplates, setLocalTaskTemplates] =
    useState<BoltTaskTemplates>([defaultTaskTemplate]);

  return (
    <div className="bolt-task-type-form-wrapper">
      <FieldFormV2<BoltTaskTemplates>
        ref={taskTypeFormRef}
        onFieldChanged={(value) => {
          setLocalTaskTemplates(value);
        }}
        onFormSubmit={() =>
          submitTaskTemplates(
            localTaskTemplates,
            taskExecutionTypeData,
            onSave ? async () => await onSave() : async () => {}
          )
        }
      >
        <div className="bolt-task-type-form-body">
          <div className="bolt-task-type-form-body-content">
            <CreateBoltTaskTemplateFormContainer
              taskTemplates={localTaskTemplates}
              updateTaskTemplates={setLocalTaskTemplates}
              apiBaseUrl={apiBaseUrl}
              assigneeOdataUrl={assigneeOdataUrl}
              getAuthRequestHeader={getAuthRequestHeader}
              richTextEditorsOutputTextType={richTextEditorsOutputTextType}
              taskExecutionTypeData={taskExecutionTypeData}
              updateTaskExecutionTypeData={(updatedModel) => {
                setTaskExecutionTypeData(updatedModel);
              }}
              workflowType={workflowType}
              showWorkflowTypeSelector={showWorkflowTypeSelector}
              entityTypeOptions={entityTypeOptions}
            />
            <FieldV2
              fieldProps={
                {
                  type: "Switch",
                  className: "is-active-switch",
                  fieldKey: "BoltTaskType__isActive",
                  label: "Active",
                  value: localTaskTemplates.at(0)?.isActive ?? true,
                  large: true,
                  onSubmit: (value) => {
                    if (typeof value === "boolean") {
                      setLocalTaskTemplates((prev) => {
                        const updated = [...prev];
                        updated[0] = { ...updated[0], isActive: value };
                        return updated;
                      });
                    }
                  },
                } as SwitchFieldProps
              }
            />
          </div>
        </div>
      </FieldFormV2>
      <Footer>
        <ActionButtons
          actions={[
            {
              text: "Cancel",
              onActionClick: onCancel,
            },
            {
              text: "Create",
              isPrimary: true,
              onActionClick: () => {
                taskTypeFormRef.current?.submit();
              },
            },
          ]}
        />
      </Footer>
    </div>
  );
};
